import { logger } from "@/logging";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function installGtm(gtmId: string): void {
  if (!gtmId || document.getElementById("ew-gtm")) return;

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const script = document.createElement("script");
  script.id = "ew-gtm";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  logger.info({ message: "Google Tag Manager initialised" });
}

export function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event: name, ...params });
  logger.debug({ message: "Analytics event", eventName: name });
}
